import { render, staticRenderFns } from "./TemplateSo.vue?vue&type=template&id=61dc687a&scoped=true"
import script from "./TemplateSo.ts?vue&type=script&lang=ts&external"
export * from "./TemplateSo.ts?vue&type=script&lang=ts&external"
import style0 from "./TemplateSo.scss?vue&type=style&index=0&id=61dc687a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc687a",
  null
  
)

export default component.exports